import { Type } from '@sinclair/typebox';
export const LiftPlanEntrySchema = Type.Object({
    id: Type.String(),
    number: Type.Number(),
    description: Type.Union([Type.String(), Type.Null()]),
    dueDate: Type.Union([Type.String(), Type.Null()]),
    amount: Type.Number(),
    retention: Type.Number(),
    amountDue: Type.Number(),
    invoicedDate: Type.Union([Type.String(), Type.Null()]),
    paymentDate: Type.Union([Type.String(), Type.Null()]),
    comment: Type.Union([Type.String(), Type.Null()]),
});
export const LiftPlanSubtotalSchema = Type.Object({
    id: Type.String(),
    description: Type.String(),
    amount: Type.Number(),
});
export const LiftPlanSchema = Type.Object({
    id: Type.String(),
    projectId: Type.String(),
    name: Type.String(),
    contractSum: Type.Number(),
    retentionPercentage: Type.Number(),
    entries: Type.Array(LiftPlanEntrySchema),
    subtotals: Type.Array(LiftPlanSubtotalSchema),
});
